<script setup lang="ts">
import { computed } from "vue";
import type { SVGAttributes } from "vue";

export interface HamburgerMenuProps {
  /** A string representing the ARIA label for the element in closed state. */
  ariaLabelClosed?: string;
  /** A string representing the ARIA label for the element in opened state. */
  ariaLabelOpened?: string;
}

const { ariaLabelClosed, ariaLabelOpened } = defineProps<HamburgerMenuProps>();
const isOpen = defineModel<boolean>();

const ariaAttributes = computed(() => ({
  "aria-expanded": isOpen.value,
  "aria-label": isOpen.value
    ? ariaLabelOpened || "Close navigation"
    : ariaLabelClosed || "Open navigation",
}));
const svgProps: SVGAttributes = {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "2",
};
const classes =
  "absolute top-[calc(50%-12px)] left-[calc(50%-12px)] h-6 w-6 motion-safe:transition-all"; // 12px is: size of SVG / 2
</script>

<template>
  <button
    class="relative h-11 w-11 rounded-md p-2 hover:text-deep-blue"
    v-bind="ariaAttributes"
    data-testid="hamburger-menu"
    @click="isOpen = !isOpen"
  >
    <svg v-bind="svgProps" viewBox="0 0 20 20" :class="[classes, { 'scale-0 opacity-0': isOpen }]">
      <path d="M1 4h18M1 10h18M1 16h18" />
    </svg>
    <svg v-bind="svgProps" viewBox="0 0 20 20" :class="[classes, { 'scale-0 opacity-0': !isOpen }]">
      <path d="M3 3 17 17M17 3 3 17" />
    </svg>
  </button>
</template>
